import { ReactElement, useEffect, useState } from 'react';
import Modal from 'react-modal';
import { useRouteLoaderData } from 'react-router-dom';

import './';
import { z } from 'zod';

import { useUpdateDependentForm } from '../../../../../../contexts/UpdateDependentFormProviderGdf';
import { useBoostedPlanDataStore } from '../../../../../../stores/useBoostedPlanDataStore';
import {
  useDependentAddDataStore,
  useDependentIdStore,
  useDependentOpenModalDataStore,
} from '../../../../../../stores/useDependentStore';
import { usePlansDataStore } from '../../../../../../stores/usePlansDataStore';
import { useVidaCountStore } from '../../../../../../stores/useQuantidadeVidas';
import {
  changeCivilStatus,
  changeGender,
} from '../../../../../../utils/ChangeArrays';
import { Button } from '../../../../../Button';
import { SaveIcon } from '../../../../../icons/SaveIcon';
import { Input } from '../../../../../Input';
import { Select } from '../../../../../Select';
import { dependentsSchema } from '../../../../data/schema GDF/dependentsSchema';

function validateDependent(obj: any): boolean {
  try {
    dependentsSchema.parse(obj);
    return true;
  } catch (error) {
    if (error instanceof z.ZodError) {
      return false;
    }
    return false;
  }
}

Modal.setAppElement('#root');

type DependentFormProps = {
  isGdf: boolean;
  AlteraPlano: boolean;
  parentageOptions: any[];
  schoolingOptions: any[];
};

export function DependentForm({
  isGdf,
  AlteraPlano,
  parentageOptions,
  schoolingOptions,
}: DependentFormProps): ReactElement {
  const {
    register,
    handleSubmit,
    onSubmit,
    errors,
    watch,
    setValue,
    getValues,
    trigger,
  } = useUpdateDependentForm();
  const initialPlanData: any = useRouteLoaderData('token-dependente');
  const setAddDependent = useDependentAddDataStore(x => x.setdependentAddData);
  const boostedPlanData = useBoostedPlanDataStore(x => x.data);
  const DependentOpenModal = useDependentOpenModalDataStore(x => x.data);
  const setDependentOpenModal = useDependentOpenModalDataStore(
    x => x.setdependentOpenModalData,
  );
  const setCountVida = useVidaCountStore(x => x.setVidaCount);
  const [clinico, setClinico] = useState(false);
  const [dependentPlanData, setDependentPlanData]: any = useState();
  const plansData = usePlansDataStore(x => x.data);

  const Planos = plansData ?? [
    {
      Id: 119,
      Nome: 'OdontoClinico - apenas R$ 22,90 por Dependente',
      valor: '22,90',
    },
    {
      Id: 252,
      Nome: 'OdontoDoc - apenas R$ 32,90 por Dependente',
      valor: '32,90',
    },
    {
      Id: 206,
      Nome: 'OdontoProtese - apenas R$ 89,90 por Dependente',
      valor: '89,90',
    },
    {
      Id: 251,
      Nome: 'OdontoOrto - apenas R$ 110,00 por Dependente',
      valor: '110,00',
    },
  ];

  changeGender(initialPlanData.listaSexos);
  changeCivilStatus(initialPlanData.listaEstadosCivil);
  const data = initialPlanData;
  const dependentes = watch('dependents') || [];
  const plano = watch('Associado.plano');
  const id = useDependentIdStore(state => state.id);
  const setId = useDependentIdStore(state => state.setId);

  const Id = id || 0;
  const dependenteData = dependentes[Id];
  const dependentPlan = watch(`dependents.${Id}.plano`);
  const isEmptyDependent = (dependent: any) =>
    !dependent?.name &&
    !dependent?.cpf &&
    !dependent?.birthDate &&
    !dependent?.civilStatus &&
    !dependent?.educationLevel &&
    !dependent?.gender &&
    !dependent?.parentage &&
    !dependent?.mothersName;

  const saveDependent = async () => {
    const currentDependentes = getValues('dependents') || [];
    const currentDependente = currentDependentes[Id];

    if (!clinico && isGdf) {
      setValue(`dependents.${Id}.plano`, String(plano), {
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue(
        `dependents.${Id}.plano_vl`,
        boostedPlanData?.produtoComercial?.formasPagamentoIndividual?.[0]
          ?.vl_valor || '0',
        { shouldDirty: true, shouldValidate: true },
      );
    } else if (!isGdf && AlteraPlano) {
      setValue(`dependents.${Id}.plano`, String(dependentPlan), {
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue(
        `dependents.${Id}.plano_vl`,
        String(plansData?.find(x => x.Id == dependentPlan)?.valor) || '0',
        { shouldDirty: true, shouldValidate: true },
      );
    } else if (!isGdf && !AlteraPlano) {
      setValue(`dependents.${Id}.plano`, String(plano), {
        shouldDirty: true,
        shouldValidate: true,
      });
      setValue(
        `dependents.${Id}.plano_vl`,
        String(plansData?.find(x => x.Id == plano)?.valor) || '0',
        { shouldDirty: true, shouldValidate: true },
      );
    } else {
      setValue(
        `dependents.${Id}.plano_vl`,
        Planos.find(x => x.Id == Number(dependentPlan))?.valor || '0',
        { shouldDirty: true, shouldValidate: true },
      );
    }
    validateDependent(currentDependente);
    const isValid = await trigger(`dependents.${Id}`);

    if (!isValid) {
      alert('Verifique os dados do dependente antes de salvar.');
      return;
    }

    setAddDependent(true);
    const updatedDependentes = getValues('dependents') || [];
    setValue('dependents', [...updatedDependentes], {
      shouldDirty: true,
      shouldValidate: true,
    });
    setCountVida(
      updatedDependentes.filter(dependent => dependent?.name || dependent?.cpf)
        .length,
    );
    alert('Dependente salvo com sucesso!');
    setDependentOpenModal(false);
  };
  const openModal = () => {
    setDependentOpenModal(true);
    const emptyIndex = dependentes.findIndex(isEmptyDependent);
    setId(emptyIndex >= 0 ? emptyIndex : dependentes.length);
  };

  const closeModal = () => {
    setDependentOpenModal(false);
  };
  useEffect(() => {
    setDependentOpenModal(false);
  }, []);

  useEffect(() => {
    if (plano == '124') {
      setClinico(true);
    } else {
      setClinico(false);
    }
  }, [plano]);

  useEffect(() => {
    fetchPlan(dependentPlan, boostedPlanData?.vendedorId);
  }, [dependentPlan]);

  useEffect(() => {
    setCountVida(
      dependentes.filter(dependent => dependent?.name || dependent?.cpf).length,
    );
  }, [dependentes]);

  const fetchPlan = async (planoId, VendedorId) => {
    const urlBaseApiV2 = process.env.REACT_APP_OG_API_URL;
    let plan = 993;
    switch (planoId) {
      case 124:
        plan = 993;
        break;
      case 252:
        plan = 998;
        break;
      case 206:
        plan = 999;
        break;
      case 251:
        plan = 1000;
        break;
      default:
        plan = 993;
        break;
    }

    if (planoId && VendedorId) {
      const response = await fetch(`
        ${urlBaseApiV2}/info/getPlansSeller?vendedorId=${VendedorId}&produtoComercial=${plan}`);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      const urlPlan = process.env.REACT_APP_OG_GET_PLAN_DETAILS_SERVER;
      const Plan = await fetch(`${urlPlan}${data.cd_Codtokenidparc}`);

      const retorno = await Plan.json();
      setDependentPlanData(retorno);
    }
  };

  return (
    <div>
      <div className="w-full relative flex min-[748px]:justify-end justify-center gap-6">
        <Button type="button" text="Adicionar Dependente" onClick={openModal} />
      </div>

      <Modal
        isOpen={DependentOpenModal}
        onRequestClose={closeModal}
        contentLabel="Formulário de Funcionário"
        className="modal"
        overlayClassName="modal-backdrop"
      >
        <h2 className="min-[748px]:text-xl text-lg font-medium text-primary-main mb-8">
          Dados do Dependente
        </h2>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="grid min-[748px]:grid-cols-3 gap-8">
            <div className="min-[748px]:col-span-2">
              <Input
                label="Nome"
                placeholder="Nome"
                errorMessage={errors?.dependents?.[Id]?.name?.message}
                {...register(`dependents.${Id}.name`)}
              />
            </div>
            <Input
              activateMask
              mask="999.999.999-99"
              label="CPF (obrigatorio a partir de 16 anos)"
              placeholder="CPF"
              errorMessage={errors?.dependents?.[Id]?.cpf?.message}
              {...register(`dependents.${Id}.cpf`)}
            />
          </div>
          <div className="grid min-[748px]:grid-cols-3 gap-8">
            <Input
              activateMask
              mask="99/99/9999"
              label="Data de nascimento"
              placeholder="dd/mm/aaaa"
              errorMessage={errors?.dependents?.[Id]?.birthDate?.message}
              {...register(`dependents.${Id}.birthDate`)}
            />
            <Select
              label="Estado civil"
              placeholder="Estado civil"
              options={[]}
              optionsFull={data.listaEstadosCivil}
              errorMessage={errors?.dependents?.[Id]?.civilStatus?.message}
              {...register(`dependents.${Id}.civilStatus`)}
            />
            <Select
              label="Escolaridade"
              placeholder="Escolaridade"
              options={[]}
              optionsFull={schoolingOptions}
              errorMessage={errors?.dependents?.[Id]?.educationLevel?.message}
              {...register(`dependents.${Id}.educationLevel`)}
            />
          </div>
          <div className="grid min-[748px]:grid-cols-3 gap-8">
            <Select
              label="Gênero"
              placeholder="Gênero"
              options={[]}
              optionsFull={data.listaSexos}
              errorMessage={errors?.dependents?.[Id]?.gender?.message}
              {...register(`dependents.${Id}.gender`)}
            />
          </div>
          <div className="grid min-[748px]:grid-cols-3 gap-8">
            <div className="min-[748px]:col-span-2">
              <Input
                label="Nome da mãe"
                placeholder="Nome da mãe"
                errorMessage={errors?.dependents?.[Id]?.mothersName?.message}
                {...register(`dependents.${Id}.mothersName`)}
              />
            </div>
            <Select
              label="Parentesco"
              placeholder="Parentesco"
              options={[]}
              optionsFull={parentageOptions}
              errorMessage={errors?.dependents?.[Id]?.parentage?.message}
              {...register(`dependents.${Id}.parentage`)}
            />
          </div>
          {clinico && isGdf && (
            <div className="grid min-[748px]:grid-cols-3 gap-8">
              <div className="min-[748px]:col-span-2">
                <Select
                  label="Plano"
                  options={[]}
                  optionsFull={Planos}
                  placeholder="Plano"
                  errorMessage={errors.dependents?.[Id]?.plano?.message}
                  {...register(`dependents.${Id}.plano`)}
                />
              </div>
            </div>
          )}
        </form>
        <div
          style={{
            display: 'flex',
            marginTop: '25px',
            flexDirection: 'row-reverse',
          }}
        >
          <Button
            type="button"
            onClick={closeModal}
            text="Cancelar"
            style={{ background: '#CC0505' }}
          />
          <Button
            type="button"
            intent="secondary"
            Icon={SaveIcon}
            onClick={saveDependent}
            text="Salvar Dependente"
            style={{ marginRight: '20px' }}
          />
        </div>
        <div
          style={{
            display: 'flex',
            marginTop: '25px',
            flexDirection: 'row-reverse',
          }}
        >
          <Button type="button" text="Fechar" onClick={closeModal} />
        </div>
      </Modal>
    </div>
  );
}

export default DependentForm;
